module.exports = __webpack_public_path__ + "static/media/enable-sound-icon.c6cb69e3.svg";